import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,

    actions: {
        getProfile({state, commit, getters}){
            return new Promise((resolve, reject) => {
                ApiService.get('/mini-profile')
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        editProfile({state, commit, getters}, form){
            return new Promise((resolve, reject) => {
                ApiService.post('/mini-profile', form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        resetPassword({state}) {
            return new Promise((resolve, reject) => {
                ApiService.post('/mini-profile/reset-password')
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        }
    }
};


